
import React from 'react';
import { TableHeader, TableRow, TableHead } from '@/components/ui/table';
import SortableTableHeader from '@/components/SortableTableHeader';
import { SortDirection } from '@/components/SortableTableHeader';

interface BehavioralTableHeaderProps {
  sortConfig: {
    key: string | null;
    direction: SortDirection;
  };
  onSort: (key: string) => void;
  isSuperAdmin: boolean;
  selectedIdealProfile: any;
  tableExpanded: boolean;
}

const BehavioralTableHeader: React.FC<BehavioralTableHeaderProps> = ({
  sortConfig,
  onSort,
  isSuperAdmin,
  selectedIdealProfile,
  tableExpanded
}) => {
  return (
    <TableHeader>
      <TableRow className="border-b border-border/60 hover:bg-transparent bg-muted/40">
        <SortableTableHeader 
          sortKey="full_name" 
          currentSortKey={sortConfig.key} 
          currentSortDirection={sortConfig.direction} 
          onSort={onSort} 
          className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider"
        >
          Name
        </SortableTableHeader>
        
        <SortableTableHeader 
          sortKey="" 
          currentSortKey={sortConfig.key} 
          currentSortDirection={sortConfig.direction} 
          onSort={() => {}} 
          className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider text-center w-20"
        >
          Self Chart
        </SortableTableHeader>
        
        <SortableTableHeader 
          sortKey="" 
          currentSortKey={sortConfig.key} 
          currentSortDirection={sortConfig.direction} 
          onSort={() => {}} 
          className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider text-center w-24"
        >
          Pattern
        </SortableTableHeader>
        
        <SortableTableHeader 
          sortKey="status" 
          currentSortKey={sortConfig.key} 
          currentSortDirection={sortConfig.direction} 
          onSort={onSort} 
          className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider text-center w-20"
        >
          Status
        </SortableTableHeader>
        
        {selectedIdealProfile && (
          <SortableTableHeader 
            sortKey="matchPercentage" 
            currentSortKey={sortConfig.key} 
            currentSortDirection={sortConfig.direction} 
            onSort={onSort} 
            className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider text-center w-20"
          >
            Match
          </SortableTableHeader>
        )}
        
        <TableHead className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider w-32">
          Actions
        </TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default BehavioralTableHeader;
